module.exports = __webpack_public_path__ + "img/AbdulkhaliqYa3qubi.08b43e4e.jpg";